import {
  IWidgetConfigurationProps,
  withWidgetConfiguration,
} from "@sgwt-widget/core";
import { h } from "preact";
import { IHeader } from "../../common/components/AgGrid";
import { PivotAgGrid } from "../../common/components/AgGrid/PivotAgGrid";

import { ApiBackedScComponent } from "../../common/components/ApiBackedScComponent";
import {
  sc_clientList_attributes,
  sc_clientList_default_attributes,
  sc_clientList_default_columns,
  sc_clientList_default_kpis,
  sc_clientList_kpis,
  scComputedKpis,
} from "../../common/components/DealListExport/SalescreditExportColumns";
import { MakeGenericApiCall } from "../../common/generic/generic-api";
import {
  CheckReponseDataForError,
  GenericFilterBuilder,
  isNotNullOrEmpty,
} from "../../common/generic/generic-helper";
import { SCKpis } from "../../common/generic/generic-sc-domain";
import { IGenericRequest } from "../../common/generic/generic-types";
import { ConvertFilter } from "../../common/salescredit/salescredit-filter-help";

import { isEqual } from "lodash";
import { SCAttributes } from "../../common/generic/generic-sc-attributes";
import { SCProfileDictionary } from "../../common/salescredit/salescredit-profile-dictionary";
import {
  BuildSalesCreditFilters,
  CreateDateFromFilter,
} from "../../common/salescredit/salescredit-search-criteria";
import {
  getColumnSelected,
  reOrderArray,
  reOrderArrayObj,
} from "../../common/utils/clientlistHelper";
import { IHeaders } from "../../common/utils/types";
import { getAllScHeaders } from "../utils/Headers";
import { getMapping } from "../utils/helper";
import { AgGridUserPreference } from "../../common/sg-dashboard/userPreference/userPreference.typings";

export interface ScClienListProps {
  filters?: { columns: string[]; [attribute: string]: string[] | string } | any;
  headers: IHeaders;
  userSelection: AgGridUserPreference;
  onColumnsMoved?: (value: AgGridUserPreference) => void;
}

interface ScClienListState {
  rowGroupColumns: string[];
  valueColumns: string[];
  visibleAttributes: any[];
  visibleKpis: any[];
  selectedColumns: string[];
  userPreferences: AgGridUserPreference;
  title: string;
  data: any[];
  headers: IHeader[];
  filter: string;
  filters: string;
}

export class SalescreditClientListClass extends ApiBackedScComponent<
  ScClienListProps & IWidgetConfigurationProps,
  ScClienListState
> {
  private attributes: any;
  private kpis: any;

  public constructor() {
    super();
    this.setState({
      data: [],
      headers: [],
      rowGroupColumns: sc_clientList_default_attributes().map(x => x.field),
      valueColumns: sc_clientList_default_kpis().map(x => x.field),
    });
    this.columnOrderChanged = this.columnOrderChanged.bind(this);
  }

  protected shouldFetchApiData(nextProps: ScClienListProps): boolean {
    if (isEqual(this.props.filters, nextProps.filters)) {
      return false;
    }
    return true;
  }

  protected renderWithDataReady(): JSX.Element {
    return (
      <div style="height: 88%; overflow:hidden;">
        <PivotAgGrid
          rowData={this.state.data}
          columnDefs={this.state.headers}
          fileName={"salescredit"}
          rowGroupColumns={this.state.rowGroupColumns}
          valueColumns={this.state.valueColumns}
          showExcelToExport={true}
          attrsCount={this.state.visibleAttributes.length}
          columnOrderChanged={userPreference =>
            this.columnOrderChanged(userPreference)
          }
          userSelection={this.state.userPreferences}
        />
      </div>
    );
  }

  protected async fetchApiData(props: ScClienListProps) {
    this.initCorrelationId();
    this.setDataStatus("loading");

    let allHeaders: any = [];

    const scReferentiel = getAllScHeaders().attributeHeaders.concat(
      getAllScHeaders().kpiHeaders
    );
    this.setState({ userPreferences: props.userSelection });
    const columnsSelected = getColumnSelected(
      props.filters,
      props.userSelection,
      scReferentiel
    );

    const filtersConverted = ConvertFilter(props.filters);
    const filters = BuildSalesCreditFilters(filtersConverted);
    const profileDictionary = new SCProfileDictionary();
    this.attributes = sc_clientList_attributes();
    this.kpis = sc_clientList_kpis();

    this.setState({ filters: GenericFilterBuilder(filters) });

    if (columnsSelected !== undefined && columnsSelected.length > 0) {
      this.SetStateForSelectedColumns(columnsSelected);
      let attributeHeaders = getAllScHeaders().attributeHeaders.filter(
        (x: any) => columnsSelected.indexOf(x.headerName) > -1
      );
      attributeHeaders = reOrderArrayObj(
        attributeHeaders,
        columnsSelected,
        "headerName"
      );
      let kpiHeaders = getAllScHeaders().kpiHeaders.filter(
        (x: any) => columnsSelected.indexOf(x.headerName) > -1
      );
      kpiHeaders = reOrderArrayObj(kpiHeaders, columnsSelected, "headerName");
      allHeaders = [].concat.apply(attributeHeaders, kpiHeaders);
    } else {
      this.SetStateForDefaultColumns();
      allHeaders = getAllScHeaders()
        .attributeHeaders.concat(getAllScHeaders().kpiHeaders)
        .filter(
          (x: any) =>
            sc_clientList_default_columns()
              .map((z: any) => z.headerName)
              .indexOf(x.headerName) > -1
        );
    }

    const visibleAttributeWithClientId = this.state.visibleAttributes
      .map((x: any) => x.field)
      .sort();

    if (
      visibleAttributeWithClientId.indexOf(SCAttributes.SC_CLIENT_LEID) ===
        -1 &&
      visibleAttributeWithClientId.indexOf(SCAttributes.SC_CLIENT_LENAME) > -1
    ) {
      visibleAttributeWithClientId.push(SCAttributes.SC_CLIENT_LEID);
    }

    const genericRequest: IGenericRequest = {
      aggregationAttributes: visibleAttributeWithClientId.join(","),
      date: CreateDateFromFilter(filtersConverted),
      filter: GenericFilterBuilder(filters),
      kpis: this.state.visibleKpis
        .filter(x => scComputedKpis().indexOf(x.field) === -1)
        .map(x => x.field)
        .sort()
        .join(","),
      sort: "-" + profileDictionary.GetKpi("", SCKpis.SC_YTD),
    };

    const responseData = await MakeGenericApiCall(
      props.headers,
      "sc",
      genericRequest,
      this.props.widgetConfiguration,
      this.state.correlationId
    );

    const errorStatus = CheckReponseDataForError(responseData);
    if (errorStatus) {
      this.setDataStatus(errorStatus);
      this.setStatusText(responseData.statusText);
      this.setState({
        data: [],
        headers: [],
      });
      return;
    }
    const result = getMapping(
      responseData,
      "",
      this.state.visibleAttributes.map(x => x.field),
      this.state.visibleKpis.map(x => x.field)
    );

    this.handleResponseData(allHeaders, result, genericRequest);
  }

  private handleResponseData(
    allHeaders: any[],
    result: any[],
    genericRequest: IGenericRequest
  ) {
    if (result.length === 0) {
      this.setState({
        data: [],
        headers: [],
      });
      this.setDataStatus("no-data");
    } else if (
      result.length > 0 &&
      genericRequest.aggregationAttributes &&
      genericRequest.kpis &&
      result.length *
        (genericRequest.aggregationAttributes.split(",").length +
          genericRequest.kpis.split(",").length) >=
        1000000
    ) {
      this.setDataStatus("client-request-error");
      this.setState({
        data: [],
        headers: [],
      });
    } else {
      this.setState({
        data: result,
        headers: allHeaders,
      });
      this.setDataStatus("ready");
    }
  }

  private columnOrderChanged(userPreferences: AgGridUserPreference) {
    if (
      userPreferences &&
      userPreferences.columns &&
      this.props.onColumnsMoved
    ) {
      this.props.onColumnsMoved(userPreferences);
    }
  }
  private SetStateForSelectedColumns(columnsSelected: any) {
    this.setState({
      selectedColumns: columnsSelected,
    });

    this.setState({
      visibleAttributes: this.attributes.filter(
        (x: any) => columnsSelected.indexOf(x.headerName) > -1
      ),
    });
    if (!isNotNullOrEmpty(this.state.visibleAttributes)) {
      this.setDataStatus("no-attribute-selected");
      return;
    }
    this.setState((prevState: ScClienListState, _: ScClienListProps) => ({
      visibleAttributes: reOrderArray(
        prevState.visibleAttributes,
        columnsSelected
      ),
    }));
    this.setState({
      visibleKpis: this.kpis.filter(
        (x: any) => columnsSelected.indexOf(x.headerName) > -1
      ),
    });
    if (!isNotNullOrEmpty(this.state.visibleKpis)) {
      this.setDataStatus("no-kpi-selected");
      return;
    }
    this.setState((prevState: ScClienListState, _: ScClienListProps) => ({
      visibleKpis: reOrderArray(prevState.visibleKpis, columnsSelected),
    }));
    this.setState((prevState: ScClienListState, _: ScClienListProps) => ({
      rowGroupColumns: prevState.visibleAttributes,
    }));
    this.setState((prevState: ScClienListState, _: ScClienListProps) => ({
      valueColumns: prevState.visibleKpis,
    }));
  }

  private SetStateForDefaultColumns() {
    this.attributes = sc_clientList_default_attributes();
    this.kpis = sc_clientList_default_kpis();
    this.setState({ visibleAttributes: this.attributes });
    this.setState({ visibleKpis: this.kpis });
    this.setState((prevState: ScClienListState, _: ScClienListProps) => ({
      rowGroupColumns: prevState.visibleAttributes,
    }));
    this.setState((prevState: ScClienListState, _: ScClienListProps) => ({
      valueColumns: prevState.visibleKpis,
    }));
  }
}

export const SalescreditClientList = withWidgetConfiguration(
  SalescreditClientListClass
);
